import {
  ActiveState,
  EntityState,
  EntityStore,
  EntityUIQuery,
  EntityUIStore,
  QueryEntity,
  StoreConfig
} from "@datorama/akita"
import produce from "immer"
import {ApiSystemLayoutResult} from "app/Interface/Api/System/ApiSystemLayout"
import {GridBreakPointKeys, GridBreakpoints} from "app/Interface/Content/Grid/WidgetGrid"

export interface SystemLayoutStoreProps extends EntityState<ApiSystemLayoutResult, string>, ActiveState {

}

export interface SystemLayoutUiProps {
  activeTab: string | undefined
}

export interface SystemLayoutUiStoreProps extends EntityState<SystemLayoutUiProps, string>, ActiveState {
  breakpoint: string | undefined
  breakpoints: GridBreakpoints
  forceBreakpoint: GridBreakPointKeys
  editLayout: string | undefined
  isDeleting: boolean
}

@StoreConfig({name: 'system.layout', resettable: true, producerFn: produce})
export class SystemLayoutStore extends EntityStore<SystemLayoutStoreProps> {
  ui: EntityUIStore<SystemLayoutUiStoreProps>

  constructor() {
    super({
      loading: undefined
    })

    const uiDefaults: SystemLayoutUiProps = {
      activeTab: undefined,
    }

    this.createUIStore({
      breakpoints: {'4k': 3600, '2k': 2400, 'hd': 1700, 'tablet': 767, 'phone': 479},
      isDeleting: false,
    }, {
      resettable: true,
      producerFn: produce
    }).setInitialEntityState(uiDefaults)
  }
}

export const systemLayoutStore = new SystemLayoutStore()

class SystemLayoutQuery extends QueryEntity<SystemLayoutStoreProps> {
  ui: EntityUIQuery<SystemLayoutUiStoreProps>

  constructor(protected store: SystemLayoutStore) {
    super(store)
    this.createUIQuery()
  }
}

export const systemLayoutQuery = new SystemLayoutQuery(systemLayoutStore)
